import { useMutation } from '@apollo/client'
import { Typography } from '@mui/material'
import React from 'react'
import Loader from '../../../common/loader/Loader'
import Page from '../../../common/page/Page'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index/index'
import { ChainMarketSettingsForm } from './ChainMarketSettingsForm'
import ChainMarketSettingsList from './ChainMarketSettingsList'
import {
  addChainMarketSettings,
  deleteChainMarketSettings,
  fetchMarketSettings,
  updateChainMarketSettings,
} from './marketSettingsQueries'
import { MarketSettings } from './types'

const marketSalesTargetTypes = ['SALES_AMOUNT_TARGET', 'SALES_VOLUME_TARGET']

interface TargetFormData {
  id?: string
  type?: string
  startDate?: string
  endDate?: string
  value?: string
}

export function ChainMarketSettingsPage() {
  const [addChainMarketSettingsMutation] = useMutation(addChainMarketSettings, {
    refetchQueries: [{ query: fetchMarketSettings }],
  })

  const [updateChainMarketSettingsMutation] = useMutation(updateChainMarketSettings, {
    refetchQueries: [{ query: fetchMarketSettings }],
  })

  const [deleteChainMarketSettingsMutation] = useMutation(deleteChainMarketSettings, {
    refetchQueries: [{ query: fetchMarketSettings }],
  })

  return (
    <Page>
      <div>
        <Typography variant='h6'>{i18n.t('admin.marketSettings.pageTitle')}</Typography>
      </div>
      <Query<{ chainMarketSettings?: MarketSettings[] }, {}> query={fetchMarketSettings}>
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <ChainMarketSettingsForm addChainMarketSettingsMutation={addChainMarketSettingsMutation} />
            <ChainMarketSettingsList
              marketSettings={data?.chainMarketSettings || []}
              updateChainMarketSettingsMutation={updateChainMarketSettingsMutation}
              deleteChainMarketSettingsMutation={deleteChainMarketSettingsMutation}
            />
          </Loader>
        )}
      </Query>
    </Page>
  )
}
